import { useState, useEffect } from "react";
import { BASE_URL } from "../constants";

export const fetchRequestsByProvider = async (providerId, status) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/requests/provider/${providerId}/status/${status}`
    );
    if (!response.ok) throw new Error("Failed to fetch requests");
    const data = await response.json();
    return { data: data.requests, error: null };
  } catch (err) {
    return { data: [], error: err.message };
  }
};

const useRequestsByProvider = (providerId, status) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    const { data, error } = await fetchRequestsByProvider(providerId, status);
    setRequests(data);
    setError(error);
    setLoading(false);
  };

  useEffect(() => {
    if (providerId) fetchData();
  }, [providerId, status]);

  return { requests, loading, error, reloadRequests: fetchData };
};

export default useRequestsByProvider;
